export default {
  "location": [2],
  "titles": [{
    "title": {
      "2": "常温商品",
      "3": "常温商品",
      "4": "常溫商品"
    },
    "link": "https://newhonmi.honmi.asia/product/search?transportId=4&orderType=1&page=1"
  }, {
    "title": {
      "2": "冷冻商品",
      "3": "冷冻商品",
      "4": "冷冻商品"
    },
    "link": "https://newhonmi.honmi.asia/product/search?transportId=4&orderType=1&page=1"
  }, {
    "title": {
      "2": "常温商品",
      "3": "常温商品",
      "4": "常溫商品"
    },
    "link": "https://newhonmi.honmi.asia/product/search?transportId=4&orderType=1&page=1"
  }],
  "titleSpace": 30,
  "categoryStatus": true,
  "categoryTitle": {
    "2": "商品分类",
    "3": "商品分类",
    "4": "商品分类"
  },
  "textColor": "#fbfbfd",
  "bgColor": "#b4a172",
  "hoverTextColor": "#b4a172",
  "fontSize": 10,
  "categoryBg": "#FFFFFF",
  "categoryTextColor": "#000000",
  "categoryTextHoverColor": "#b4a172"
};